import { render } from "./CreateSurvey.vue?vue&type=template&id=0b46cade"
import script from "./CreateSurvey.vue?vue&type=script&lang=js"
export * from "./CreateSurvey.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__